import { InvoiceItemModel } from "#src/models/InvoiceItemModel.ts";
import MembershipModel from "#src/models/MembershipModel.ts";
import calculateCouponsForRegistration from "#src/utils/calculateCouponsForRegistration.ts";
import { calculatePricingForMembership } from "#src/utils/calculatePricingForMembership.ts";
import {
  type CouponPayload,
  type Frequency,
  type MembershipStatus,
} from "#types/code-generator.ts";
import { v4 as uuid } from "uuid";

interface GetInvoiceItemForMembershipInput {
  membership: {
    id: string;
    offering: {
      program: {
        title: string;
      };
      price?: number;
      priceLevels?: {
        number: number;
        price: number;
      }[];
      prorate?: boolean;
      type?: string;
      paymentFrequency?: Frequency;
      recurringDate?: Date;
      startDate?: Date;
      endDate?: Date;
    };
    roster: {
      firstName: string;
      lastName: string;
    }[];
    status: MembershipStatus;
  };
  startDate: Date;
  coupons: CouponPayload[];
}

export function getInvoiceItemForMembership({
  membership,
  startDate,
  coupons,
}: GetInvoiceItemForMembershipInput) {
  const { proratedPrice } = calculatePricingForMembership({
    membership,
    startDate,
  });

  // console.log("price", price);

  const registrationCoupons = calculateCouponsForRegistration({
    coupons,
    registration: new MembershipModel(membership),
    startDate,
  });

  const description = `${
    membership.offering?.program?.title
  }: ${membership.roster
    .map((r) => `${r.firstName} ${r.lastName}`)
    .join(", ")}`;

  const invoiceItem = new InvoiceItemModel({
    id: uuid(),
    amount: proratedPrice,
    description,
    membership: new MembershipModel(membership),
  });

  // console.log("registrationCoupons", registrationCoupons);

  invoiceItem.coupons = registrationCoupons;

  return invoiceItem;
}
